import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AppModule } from '../../app.module';

import { MsdaSideNavService } from '../service/msda-sidenav.service';
import { SelectClientComponent } from './select-client/select-client.component';

interface Application {
  abbreviation: string;
  id: number;
  name: string;
  nameEn: string;
  description: string;
  meta: any;
  img: string;
  url: string;
  disabled: boolean;
  setHrPosition: boolean;
}
enum UserType {
  private = 'private',
  public = 'public'
}

@Component({
  selector: 'msda-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class MsdaSidenavComponent implements OnInit {
  imagesSourceUrl: string = '';
  userType: UserType = UserType.public;
  applications: {
    private: Application[];
    public: Application[];
  } = {
    private: [],
    public: []
  };
  userApps: any = {};
  userAppClients: any = {};
  applicationTypes: any = {
    private: ['PRIVATE', 'MULTI'],
    public: ['PUBLIC', 'MULTI']
  };
  selectedClientId = null;
  subscription: Subscription;

  links: any = {};
  @Input() set isPrivate(val: boolean) {
    this._isPrivate = val;
    AppModule.isPrivate = this._isPrivate;
    if (this._isPrivate) this.userType = UserType.private;
    else this.userType = UserType.public;
    this.loadApps();
  }
  _user: any;
  @Input() set user(val) {
    this._user = val;
    this.loadApps();
  }

  get user() {
    return this._user;
  }
  private _isPrivate: boolean | undefined;
  constructor(
    private _sideNav: MsdaSideNavService,
    private _dialog: MatDialog
  ) {
    this.imagesSourceUrl = AppModule.imagesSourceUrl;
  }

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }

  async ngOnInit() {
    this._sideNav.opened.subscribe(async (res) => {
      await this._sideNav.loadApps();
      this.loadApps();
    });
  }

  _setPrivate() {
    this.userType = UserType.private;
  }

  _setPublic() {
    this.userType = UserType.public;
  }

  async loadApps() {
    let apps = [...this._sideNav.applications];
    if (this._sideNav.links) this.links = this._sideNav.links;
    apps = apps
      .filter((app) => app.abbreviation !== 'PT')
      .map((app) => {
        try {
          if (app.meta) {
            app.metaJson = JSON.parse(app.meta);
            if (
              app.metaJson[this.userType] &&
              app.metaJson[this.userType].imgUrl
            )
              app.imgUrl = app.metaJson[this.userType].imgUrl;
            if (app.metaJson[this.userType] && app.metaJson[this.userType].url)
              app.url = app.metaJson[this.userType].url;
            if (app.metaJson[this.userType] && app.metaJson[this.userType].name)
              app.name = app.metaJson[this.userType].name;
            if (
              app.metaJson[this.userType] &&
              app.metaJson[this.userType].nameEn
            )
              app.nameEn = app.metaJson[this.userType].nameEn;
            if (app.metaJson[this.userType])
              app.setHrPosition =
                app.metaJson[this.userType].setHrPosition || false;
            if (app.metaJson[this.userType])
              app.orderPriority =
                app.metaJson[this.userType].orderPriority || 1000;
            if (app.metaJson[this.userType])
              app.domainType =
                app.metaJson[this.userType].domainType || 'single';

            if (
              app.metaJson[this.userType] &&
              app.metaJson[this.userType].shouldHideInsteadDisabled
            )
              app.shouldHideInsteadDisabled = true;
          }

          app.disabled = this.isPrivate && !this.userApps[app.abbreviation];
        } catch (err) {
          console.log(err);
        }
        return app;
      });
    this.applications[UserType.private] = apps
      .filter(
        (app) =>
          app.metaJson &&
          this.applicationTypes[UserType.private].indexOf(app.type) > -1 &&
          app.metaJson[UserType.private] &&
          !app.metaJson[UserType.private].hidden
      )
      .filter(
        (app) =>
          !app.metaJson[UserType.private].shouldHideInsteadDisabled ||
          (app.metaJson[UserType.private].shouldHideInsteadDisabled &&
            this.userApps[app.abbreviation])
      )
      .sort((a, b) => a.orderPriority - b.orderPriority);
    this.applications[UserType.public] = apps
      .filter(
        (app) =>
          app.metaJson &&
          this.applicationTypes[UserType.public].indexOf(app.type) > -1 &&
          app.metaJson[UserType.public] &&
          !app.metaJson[UserType.public].hidden
      )
      .sort((a, b) => a.orderPriority - b.orderPriority);
  }

  close() {
    this._sideNav.close();
  }

  async go(item: Application) {
    if (item.disabled || !item.url) return;
    if (this.userType == UserType.private) await this._goPrivate(item);
    else this._goPublic(item);
  }

  _goPrivate(item: Application) {
    if (this.userAppClients[item.abbreviation]) {
      const keys = Object.keys(this.userAppClients[item.abbreviation]);
      if (
        keys.length == 1 &&
        keys[0] == this.selectedClientId &&
        !item.setHrPosition
      ) {
        this._navigate(item.url, this.selectedClientId || undefined, item.id);
      } else {
        this._dialog
          .open(SelectClientComponent, {
            width: '761px',
            // panelClass: 'select-client',
            data: {
              clients: [
                ...Object.values(this.userAppClients[item.abbreviation])
              ],
              setHrPosition: item.setHrPosition
            }
          })
          .afterClosed()
          .subscribe((clientId: any) => {
            if (clientId) {
              this._navigate(item.url, clientId || undefined, item.id);
            }
          });
      }
    }
  }

  _goPublic(item: Application) {
    this._navigate(item.url);
  }

  _navigate(url: string, clientId?: number, applicationId?: number) {
    if (clientId) url = url.replace('${clientId}', clientId.toString());
    if (applicationId)
      url = url.replace('${applicationId}', applicationId.toString());
    this.navigate(url);
  }

  public navigate(loc: string): void {
    const token = this.isPrivate
      ? localStorage.getItem('private-token')
      : localStorage.getItem('public-token');
    const clientId = localStorage.getItem('clientId');
    const clientIdQuery = clientId ? `&&clientId=${clientId}` : '';
    // loc = this._tranformByEnv(loc);
    if (loc.includes('${token}')) {
      loc = loc.replace('${token}', token || '');
      location.href = loc;
    } else location.href = `${loc}?token=${token}${clientIdQuery}`;
  }

  get isPrivate() {
    if (this._isPrivate !== undefined) return this._isPrivate;
    else if (AppModule.isPrivate !== undefined) return AppModule.isPrivate;
    else return this.userType == UserType.private;
  }

  get lang() {
    return localStorage.getItem('msda-lang');
  }

  backButtonClick(key: string) {
    this.navigate(
      this.links[key][environment.production ? 'production' : 'staging']
    );
  }

  get logo() {
    return `${this.imagesSourceUrl}/assets/imgs/logos/msda-logo-blue-${
      this.lang || 'ge'
    }.svg`;
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/msda-sidenav/components/msda-sidenav.component.ts